// external dependencies
import { useEffect, useState } from 'react'

/* Back To Top Support */
export function handleShowBackToTop(setShouldShowBackToTop) {
	// Get the content top and height of the content block to calculate if Back to Top should show
	// If the content block is too short, no need to show the back to top button
	const contentTop = document.getElementById('related-rail-wrapper').getBoundingClientRect().top
	const contentHeight = document.getElementById('related-rail-wrapper').clientHeight
	const scrollY = window.pageYOffset || document.documentElement.scrollTop

	const shouldShow = contentTop + (contentHeight + 120) <= window.innerHeight && scrollY > 100
	setShouldShowBackToTop(shouldShow)
}

export function handleBackToTopHitFooter(setDidBackToTopHitFooter) {
	// if footer is in viewport, back to top hit the footer
	const footerPosition = document.getElementById('footer').getBoundingClientRect().top - 50 // account for margins
	const getRelatedEndTilesPosition =
		document.getElementById('related-end-tiles') &&
		document.getElementById('related-end-tiles').getBoundingClientRect().top - 50
	setDidBackToTopHitFooter(window.innerHeight > (getRelatedEndTilesPosition || footerPosition))
}

/**
 * Function to determine if any array that is part of the railing has length
 * @function determineHasAnyContent
 * @param {Array} parentArr - An array containing all data arrays within a railing (i.e. relatedArticles relatedExperts relatedReviews)
 * @returns {boolean} - Returns a boolean value indicating if any content should appear
 */

export function determineHasAnyContent(parentArr) {
	return parentArr.reduce((accumulator, parentArrItem) => {
		return accumulator || (parentArrItem && parentArrItem.length > 0) // if any parentArrItem array has length, function will always return true
	}, false)
}

// useArticle hook

/**
 * Custom hook for handling scrolling and resizing
 * @function useArticle
 * @param {Array} allRailContentArr
 * @param {boolean} shouldDisableScrolling - Optional boolean passed in to disable scrolling
 * @returns {Object} - Returns an object containing the articleState
 */
export function useArticle(allRailContentArr, shouldDisableScrolling) {
	const [shouldShowBackToTop, setShouldShowBackToTop] = useState()
	const [didBackToTopHitFooter, setDidBackToTopHitFooter] = useState()

	const hasRightRailContent = determineHasAnyContent(allRailContentArr)

	useEffect(() => {
		if (shouldDisableScrolling) {
			return
		}
		if (document.getElementById('related-rail-wrapper')) {
			function handleScroll() {
				handleShowBackToTop(setShouldShowBackToTop)
				handleBackToTopHitFooter(setDidBackToTopHitFooter)
			}

			handleBackToTopHitFooter(setDidBackToTopHitFooter) // set back to top to sit on top of footer

			window.addEventListener('scroll', handleScroll)

			return () => {
				window.removeEventListener('scroll', handleScroll)
			}
		}
	}, [shouldDisableScrolling])

	const articleState = {
		didBackToTopHitFooter,
		shouldShowBackToTop,
	}

	return {
		articleState,
		hasRightRailContent,
	}
}

export default useArticle
